// @ts-nocheck
import React, { ReactNode } from 'react';
import Cookies from 'universal-cookie';
/* import packageJson from '../../../package.json'; */

const cookies = new Cookies();
/* const applicationVersion = process.env.REACT_APP_VERSIONNUMBER; */

interface CacheBusterState {
    loading: boolean,
    isLatestVersion: boolean,
    refreshCacheAndReload(): void,
}
interface CacheBusterProps {
    children(state: CacheBusterState): ReactNode;
}

export default class CacheBuster extends React.Component<CacheBusterProps, CacheBusterState> {
    constructor(props: CacheBusterProps) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            refreshCacheAndReload: () => {
                console.log('Clearing cache and hard reloading...')
                if (caches) {
                    // Service worker cache should be cleared with caches.delete()
                    caches.keys().then(function (names) {
                        for (let name of names) caches.delete(name);
                    });
                }
                // delete browser cache and hard reload
                window.location.reload();
            }
        };
    }

    componentDidMount() {
        fetch('versionInfo', { cache: 'no-store' })
            .then(response => response.text())
            .then(data => {
                const latestVersion = data;
                const cachedVersion = cookies.get('portalVersion');
                console.log(`latestVersion - ${latestVersion}.`);
                console.log(`cachedVersion - ${cachedVersion}.`);

                if (latestVersion && !cachedVersion) {
                    //Version has not been set to the cookies, save it
                    console.log(`Set a new version - ${latestVersion}.`);
                    cookies.set('portalVersion', `${latestVersion}`, { path: '/' });
                    this.setState({ loading: false, isLatestVersion: true });
                }
                else if (latestVersion && cachedVersion && !latestVersion.startsWith("development")) {
                    const shouldForceRefresh = this.compareVersions(latestVersion, cachedVersion);
                    if (shouldForceRefresh) {
                        console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                        //set cookie version to the new version number
                        cookies.set('portalVersion', `${latestVersion}`, { path: '/' });
                        //set isLatestVersion to false so CacheBuster will clear the cache
                        this.setState({ loading: false, isLatestVersion: false });
                    } else {
                        console.log(`You already have the latest Portal version - ${latestVersion}. No cache refresh needed.`);
                        this.setState({ loading: false, isLatestVersion: true });
                    }
                }
                else {
                    console.log("No need to clear the cache for development version")
                    this.setState({ loading: false, isLatestVersion: true });
                }
            });
    }

    render() {
        const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
        return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
    }

    compareVersions = (latestVersion: string, cachedVersion: string) => {
        //remove single and double quotes
        let latestVersionWithoutQuotes = latestVersion.replace(/["']/g, "");
        let cachedVersionWithoutQuotes = cachedVersion.replace(/["']/g, "");

        //Split the version tags by the dots
        const latestVersionNumberTags = latestVersionWithoutQuotes.split(/\./g);
        const cachedVersionNumberTags = cachedVersionWithoutQuotes.split(/\./g);

        while (latestVersionNumberTags.length || cachedVersionNumberTags.length) {
            //Move to the next tag in the array
            const latestNumberTag = Number(latestVersionNumberTags.shift());
            const cachedNumberTag = Number(cachedVersionNumberTags.shift());

            //if sub version numbers are the same continue to the next tag
            if (latestNumberTag === cachedNumberTag) continue;
            // return true if the latest version is higher than the cached
            // or the cached version tag is not a number
            return latestNumberTag > cachedNumberTag || isNaN(cachedNumberTag);
        }
        return false;
    };
}